<template>
    <article
        class="tw:relative tw:border-b tw:border-surface-200 tw:bg-surface-0 tw:p-4 tw:pl-6 tw:text-surface-900 tw:dark:border-surface-700 tw:dark:bg-surface-900 tw:dark:text-surface-0"
        data-test="deadline-reminder"
    >
        <span
            v-if="!notification.read"
            class="tw:absolute tw:top-6 tw:left-2 tw:size-2 tw:rounded-full tw:bg-red-500"
            aria-label="Unread"
        />
        <div class="tw:flex tw:items-start tw:justify-between tw:gap-3">
            <p class="tw:text-xs tw:font-semibold tw:text-primary">Deadline reminder</p>
            <Button
                :icon="notification.read ? 'pi pi-circle' : 'pi pi-check-circle'"
                :aria-label="notification.read ? 'Mark as unread' : 'Mark as read'"
                size="small"
                text
                rounded
                @click="$emit('toggle-read')"
            />
        </div>
        <p class="tw:mt-1 tw:text-sm tw:break-words tw:text-surface-700 tw:dark:text-surface-200">{{ notification.course_title }}</p>
        <a
            :href="notification.inbox_link"
            class="tw:mt-2 tw:block tw:text-base tw:font-semibold tw:break-words tw:text-primary"
            @click.prevent="$emit('open')"
        >
            {{ notification.title }}
        </a>
        <p class="tw:mt-2 tw:text-sm tw:text-surface-700 tw:dark:text-surface-200">
            Due <time :datetime="notification.due_at">{{ notification.deadline }}</time>
        </p>
        <p
            v-if="notification.already_submitted"
            class="tw:mt-2 tw:text-sm tw:font-semibold tw:text-surface-900 tw:dark:text-surface-0"
            data-test="already-submitted"
        >
            Already submitted
        </p>
        <p class="tw:mt-2 tw:text-sm tw:text-surface-700 tw:dark:text-surface-200">{{ notification.body }}</p>
        <a
            :href="notification.inbox_link"
            class="tw:mt-3 tw:inline-block tw:text-sm tw:font-semibold tw:text-primary tw:underline"
            @click.prevent="$emit('open')"
        >
            View Activity
        </a>
    </article>
</template>

<script setup>
import Button from 'primevue/button';

defineProps({
    notification: {
        type: Object,
        required: true,
    },
});

defineEmits(['open', 'toggle-read']);
</script>
